import { useState, type FormEvent } from 'react'
import { authApi, passwordReady } from '../../lib/auth'
import { BTN_PRIMARY, Card, Field, INPUT, NewPasswordFields, Notice } from './AuthUi'

// `forced` = konto z dawnym hasłem tymczasowym od admina (sprzed zaproszeń mailem) —
// nowe konta ustawiają hasło z linku i tu nie trafiają.
export function PasswordChangeForm({ forced, onChanged }: { forced: boolean; onChanged: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [repeat, setRepeat] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const [done, setDone] = useState(false)

  const ready = current && passwordReady(next, repeat)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    setDone(false)
    authApi.changePassword(current, next).then(
      () => {
        setCurrent(''); setNext(''); setRepeat('')
        setBusy(false); setDone(true)
        onChanged()
      },
      (e: Error) => { setErr(e.message); setBusy(false) },
    )
  }

  return (
    <Card
      title={forced ? 'Ustaw własne hasło' : 'Zmiana hasła'}
      subtitle={forced
        ? 'Logujesz się hasłem tymczasowym od admina — zamień je na własne.'
        : 'Po zmianie pozostałe urządzenia zostaną wylogowane.'}
    >
      <form onSubmit={submit} className="flex max-w-sm flex-col gap-3">
        {err && <Notice tone="error" onClose={() => setErr(null)}>{err}</Notice>}
        {done && <Notice tone="ok" onClose={() => setDone(false)}>Hasło zmienione.</Notice>}
        <Field label={forced ? 'Hasło tymczasowe' : 'Obecne hasło'}>
          <input className={INPUT} type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
        </Field>
        <NewPasswordFields next={next} repeat={repeat} onNext={setNext} onRepeat={setRepeat} />
        <button type="submit" disabled={busy || !ready} className={`${BTN_PRIMARY} self-start`}>
          {busy ? 'Zapisywanie…' : 'Zmień hasło'}
        </button>
      </form>
    </Card>
  )
}
